import { useMemo, useState } from "react";

export function useBooleanState(initialValue: boolean | (() => boolean)) {
  const [val, set] = useState(initialValue);

  const [setTrue, setFalse, toggle] = useMemo(() => {
    return [() => set(true), () => set(false), () => set((prevVal) => !prevVal)];
  }, []);
  return {
    val,
    set,
    setTrue,
    setFalse,
    toggle,
  };
}
